import { useContext } from "react";
import style from "./PathCategories.module.css";
import PathPreviewContext from "../../contexts/PathPreviewContext";
import { useLocalized } from "@/i18n/useLocalized";

function PathCategories({ categories }) {
	const l = useLocalized();
	const { path } = useContext(PathPreviewContext);

	return (
		<ul className={style.categories}>
			{path.categories.map((category) => (
				<li key={category.slug}>{l(category, "name")}</li>
			))}
		</ul>
	);
}

export default PathCategories;
